import { Action, createReducer, on } from '@ngrx/store';
import * as fromActions from './ranklist.actions';
import * as fromState from './ranklist.state';

const ranklistReducer = createReducer(
  fromState.getInitialRanklistState(),
  on(fromActions.loadManySuccess, (state, { items }) => {
    return fromState.adapter.setAll(
      items!.map((item) => {
        return { ...item, id: item.requestId } as fromState.RanklistEntity;
      }),
      state,
    );
  }),
);

export function reducer(
  state: fromState.RanklistState | undefined,
  action: Action,
) {
  return ranklistReducer(state, action);
}
